// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9.48063 2.5L11.4806 5H23V21H1V2.5H9.48063ZM14 19H16.0039V17.0039H18.0039V15H16.0039V13.0039H18.0039V11H16.0039V9.00391H18.0039V7H16V9H14V11.0039H16V13H14V15.0039H16V17H14V19Z"}}]};

const FolderZipFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'folder-zip-filled',
    ref,
    icon: element,
  },
));

FolderZipFilledIcon.displayName = 'FolderZipFilledIcon';

export default FolderZipFilledIcon;
